import { Link } from 'react-router-dom'
import { User } from 'lucide-react'

interface ProfileCompletionBadgeProps {
  completionPercent: number
  missing: string[]
  userRole: 'customer' | 'broker'
}

export default function ProfileCompletionBadge({
  completionPercent,
  missing,
  userRole,
}: ProfileCompletionBadgeProps) {
  if (completionPercent >= 100) return null

  const profilePath = userRole === 'customer' ? '/customer/profile' : '/broker/profile'

  return (
    <Link
      to={profilePath}
      className="flex items-center gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg hover:bg-amber-100 transition-colors"
    >
      <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
        <User className="text-amber-600" size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-amber-900">
          Complete your profile ({completionPercent}%)
        </p>
        <p className="text-xs text-amber-700 truncate">
          {missing.length > 0
            ? `Missing: ${missing.slice(0, 3).join(', ')}${missing.length > 3 ? '...' : ''}`
            : 'Add details to get the most from LoanLoop'}
        </p>
      </div>
      <span className="text-amber-600 text-sm font-medium whitespace-nowrap">Complete →</span>
    </Link>
  )
}
